import userFlowMixin from '@/modules/User/mixins/userFlowMixin'

export default {
  mame: 'damageItemPhotoclaim',
  mixins: [userFlowMixin],
  props: {
    damage: {
      type: Object,
      required: true
    },
    options:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    flowName() {
      return this.getUserFlow
    }
  }
}
